import * as Constants from './constants'

const initialState = {
  testsLoading: false,
  tests: [],
  deleteLoading: false,
}

const reducer = function questionReducer (state = initialState, action) {
  switch (action.type) {
    case Constants.TEST_REQUEST:
      return {
        ...state,
        testsLoading: true,
        messages: [{
          body: 'Fetching tests...!',
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.TEST_SUCCESS:
      return {
        tests: action.result.data,
        testsLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.TEST_ERROR:
      return {
        testsLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.DELETE_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        messages: [{
          body: 'Deleting Test...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.DELETE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        messages: [{
          body: action.data.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.DELETE_ERROR:
      return {
        ...state,
        deleteLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.VISIBILITY_REQUEST:
      return {
        ...state,
        tests: action.tests,
        messages: [{
          body: 'Changing Visibility...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.VISIBILITY_SUCCESS:
      return {
        ...state,
        messages: [{
          body: action.data.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.VISIBILITY_ERROR:
      return {
        ...state,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    default:
      return state
  }
}

export default reducer
